import { Controller } from "@hotwired/stimulus"

// Ticks or unticks every row checkbox from one header checkbox.
//
//   <form data-controller="select-all">
//     <input type="checkbox" data-action="select-all#toggle">
//     <input type="checkbox" data-select-all-target="item">
//   </form>
export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    this.itemTargets.forEach((item) => { item.checked = event.target.checked })
  }
}
